<script lang="ts">
    import { LL } from "../../../i18n/i18n-svelte";
</script>

<span class="text-l text-center">{$LL.mapEditor.entityEditor.trashTool.delete()}</span>

<style>
</style>
